import {
    default as actions,
    UPLOAD_READY,
    UPLOAD_CODE,
    UPLOAD_CODE_PROGRESS,
    UPLOAD_FIRMWARE,

} from './action';
import CONSTANT from '../../constant';

const defaultState = {
    progress_status: CONSTANT.UPLOAD_STATUS.READY,
    progress_percent: 0
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPLOAD_READY:
        case UPLOAD_CODE:
        case UPLOAD_CODE_PROGRESS:
        case UPLOAD_FIRMWARE:
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
};

export default {
    reducer,
    actions
};